import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { ButtonBase, CardContent, Icon, IconButton } from "@mui/material";
import Grid from "@mui/material/Grid";
import MDBadge from "components/MDBadge";
import { INTERNAL } from "const";
import { EXTERNAL } from "const";
import MDButton from "components/MDButton";
import { usePermissionMonitor } from "components/PermissionMonitor";
import { useLanguage } from "contexts/language.context";

export default function SubscriptionItem({
  subscription,
  live,
  template,
  selected,
  onUnsubsribe,
  onEditDate,
  noUnsubscribe = true,
  sx,
  counts,
}) {
  const { label } = useLanguage();
  const plan = subscription?.subscription;
  const can = usePermissionMonitor();

  console.log("PLAN: ", plan);

  return (
    <Card
      sx={(theme) => ({
        boxShadow: "none",
        border:
          live || selected
            ? "1px solid " + theme.palette.info.main
            : "1px solid rgba(0, 0, 0, 0.15)",
        boxSizing: "border-box",
        backgroundColor:
          live || selected ? theme.palette.info.main + "11" : "white",
        borderRadius: "6px",
        ...sx,
      })}
    >
      <CardContent sx={{ p: 0, m: 0 }}>
        <MDBox
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="start"
          sx={{ mt: 1.5, mx: 2, mr: 1.5 }}
        >
          <MDTypography variant="h6">{plan?.name}</MDTypography>

          <MDBox
            p={0}
            m={0}
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap={1}
          >
            <MDBadge
              badgeContent={`${plan?.period} ${plan?.period == 1 ? label("month-singular") : label("month-plural")}`}
            />

            {!template && (
              <MDBadge
                sx={{ ml: -1 }}
                color={
                  live
                    ? "success"
                    : subscription.cancelledAt
                      ? "error"
                      : "warning"
                }
                badgeContent={
                  live
                    ? "Live"
                    : subscription.cancelledAt
                      ? "Cancelled"
                      : "Expired"
                }
              />
            )}

            {live && !template && !noUnsubscribe && (
              <>
                {can("isAdmin") && (
                  <ButtonBase
                    focusRipple
                    elevation={2}
                    sx={{ ml: -1 }}
                    onClick={onEditDate}
                  >
                    <MDBadge
                      color="info"
                      badgeContent={
                        <>
                          <Icon>edit</Icon>&nbsp;{label("edit")}
                        </>
                      }
                      clickable
                    />
                  </ButtonBase>
                )}
                <ButtonBase
                  focusRipple
                  elevation={2}
                  sx={{ ml: -1 }}
                  onClick={onUnsubsribe}
                >
                  <MDBadge
                    color="error"
                    badgeContent={
                      <>
                        <Icon>cancel</Icon>&nbsp;{label("unsubscribe")}
                      </>
                    }
                    clickable
                  />
                </ButtonBase>
              </>
            )}
            {template && (
              <MDTypography variant="h6">
                ${plan?.price.toFixed(2)}
              </MDTypography>
            )}
          </MDBox>
        </MDBox>
        {plan.type === EXTERNAL && (
          <MDTypography
            variant="h6"
            sx={{ fontWeight: "500", fontSize: "14px", mx: 2 }}
          >
            {label("auditor-singular")}:&nbsp;
            {plan?.account?.name}
          </MDTypography>
        )}
        <MDTypography
          variant="body2"
          sx={{ fontWeight: "400", fontSize: "14px", mx: 2 }}
        >
          {plan?.description}
        </MDTypography>
        {!template && (
          <Grid container sx={{ px: 2, mt: 1, mb: 1 }}>
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <MDTypography
                variant="body2"
                sx={{ fontWeight: "400", fontSize: "12px" }}
              >
                {label("started-on")}:
              </MDTypography>
              <MDTypography
                variant="body2"
                sx={{ fontWeight: "500", fontSize: "12px" }}
              >
                {new Date(subscription.startedAt).toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                })}
              </MDTypography>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <MDTypography
                variant="body2"
                sx={{ fontWeight: "400", fontSize: "12px" }}
              >
                {live
                  ? label("ends-on")
                  : subscription.cancelledAt
                    ? label("cancelled-on")
                    : label("expired-on")}{" "}
                :
              </MDTypography>
              <MDTypography
                variant="body2"
                sx={{ fontWeight: "500", fontSize: "12px" }}
              >
                {(subscription.cancelledAt
                  ? new Date(subscription.cancelledAt)
                  : new Date(subscription.expiresAt)
                ).toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                })}
              </MDTypography>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <MDTypography
                variant="body2"
                sx={{ fontWeight: "400", fontSize: "12px" }}
              >
                Modules:
              </MDTypography>
              <MDTypography
                variant="body2"
                sx={{ fontWeight: "500", fontSize: "12px" }}
              >
                {plan.modules?.map((m) => m.name).join(", ") || "None"}
              </MDTypography>
            </Grid>
          </Grid>
        )}
        <Grid
          container
          sx={{ borderTop: "1px solid rgba(0, 0, 0, .15)", mt: 1.5 }}
        >
          {[
            {
              label: `${label("audit-limit-every")} ${[
                plan.periodDay
                  ? `${plan.periodDay} ${label(
                      plan.periodDay === 1 ? "day-singular" : "day-plural",
                    )}`
                  : false,
                plan.periodMonth
                  ? `${plan.periodMonth} ${label(
                      plan.periodMonth === 1
                        ? "month-singular"
                        : "month-plural",
                    )}`
                  : false,
                plan.periodYear
                  ? `${plan.periodYear} ${label(
                      plan.periodYear === 1 ? "year-singular" : "year-plural",
                    )}`
                  : false,
              ]
                .filter((v) => v != false)
                .join(" ")}:`,
              value:
                plan?.maxAuditsPeriod == -1
                  ? label("unlimited")
                  : (counts ? counts?.audits + "/" : "") +
                    plan?.maxAuditsPeriod,
            },
            ...(plan.modules.find((v) => v.id == 1)
              ? [
                  {
                    label: `${"Mystery " + label("audit-limit-every")} ${[
                      plan.periodDay
                        ? `${plan.periodDay} ${label(
                            plan.periodDay === 1
                              ? "day-singular"
                              : "day-plural",
                          )}`
                        : false,
                      plan.periodMonth
                        ? `${plan.periodMonth} ${label(
                            plan.periodMonth === 1
                              ? "month-singular"
                              : "month-plural",
                          )}`
                        : false,
                      plan.periodYear
                        ? `${plan.periodYear} ${label(
                            plan.periodYear === 1
                              ? "year-singular"
                              : "year-plural",
                          )}`
                        : false,
                    ]
                      .filter((v) => v != false)
                      .join(" ")}:`,
                    value:
                      plan?.maxAuditsMysteryPeriod == -1
                        ? label("unlimited")
                        : (counts ? counts?.mysteryAudits + "/" : "") +
                          plan?.maxAuditsMysteryPeriod,
                  },
                ]
              : []),
            ...(plan.type === INTERNAL
              ? [
                  {
                    label: label("users-limit") + ": ",
                    value:
                      plan?.maxUsers == -1
                        ? label("unlimited")
                        : (counts ? counts?.users + "/" : "") + plan?.maxUsers,
                  },
                  {
                    label: label("sub-accounts-limit") + ": ",
                    value:
                      plan?.maxSubAccounts == -1
                        ? label("unlimited")
                        : (counts ? counts?.subAccounts + "/" : "") +
                          plan?.maxSubAccounts,
                  },
                  {
                    label: label("branch-groups-limit") + ": ",
                    value:
                      plan?.maxBranchGroups == -1
                        ? label("unlimited")
                        : (counts ? counts?.branchGroups + "/" : "") +
                          plan?.maxBranchGroups,
                  },
                ]
              : []),
            {
              label: label("type-singular") + ": ",
              value:
                plan?.type == EXTERNAL
                  ? label("Third-Party")
                  : label("Self-Service"),
            },
            {
              label: label("country-plural") + ": ",
              value: plan?.countries.map((c) => c.name).join(", "),
            },
            {
              label: label("notify-expiry-to-account-manager") + ": ",
              value: plan?.notifyExpiry ? "Yes" : "No",
            },
          ].map((feature, index) => (
            <SubscriptionFeature feature={feature} isLast />
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
}

function SubscriptionFeature({ feature, isLast }) {
  return (
    <Grid
      item
      container
      xs={12}
      alignItems="center"
      sx={{
        alignItems: "center",
        borderBottom: "1px solid rgba(0, 0, 0, .15)",
        mx: isLast ? 0 : 2,
        px: isLast ? 2 : 0,
      }}
    >
      <Grid item xs>
        <MDTypography
          variant="body2"
          sx={{ fontWeight: "400", fontSize: "14px" }}
        >
          {feature.label}
        </MDTypography>
      </Grid>
      <Grid item>
        <MDTypography
          variant="body2"
          sx={{ fontWeight: "500", fontSize: "14px" }}
        >
          {feature.value}
        </MDTypography>
      </Grid>
    </Grid>
  );
}
